import styled, { css } from 'styled-components';

const FiltersWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing.km2};
    width: 100%;

    fuel-typography {
      margin-bottom: ${theme.spacing.km4};
      :not(:first-child) {
        margin-top: ${theme.spacing.km2};
      }
    }

    fuel-radio:not(:last-child) {
      margin-bottom: ${theme.spacing.km4};
    }
  `}
`;

export { FiltersWrapper };
